import { render, staticRenderFns } from "./MtOrderDetail.vue?vue&type=template&id=0960fe8c&scoped=true&"
import script from "./MtOrderDetail.vue?vue&type=script&lang=js&"
export * from "./MtOrderDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0960fe8c",
  null
  
)

export default component.exports